// extracted by mini-css-extract-plugin
export var link = "link-module--link--QecRw";
export var link_small = "link-module--link_small--ntxoM";
export var link_withArrow = "link-module--link_with-arrow--EXdgA";
export var link__arrow = "link-module--link__arrow--majpL";
export var arrow = "link-module--arrow--gzvv4";